module.exports = __webpack_public_path__ + "img/71cd2e5.png";